<template>
  <canvas ref="chartRef"></canvas>
</template>

<script>
import { defineComponent, onMounted, ref, watch, inject } from 'vue'
import Chart from 'chart.js' // auto-registers all required chart types
import { helper as $h } from '@/utils/helper' // optional, replace with JSON.parse if needed
import cash from 'cash-dom' // if you're using it for DOM manipulation, otherwise remove

export default defineComponent({
  name: 'BaseChart',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['line', 'bar', 'pie', 'doughnut'].includes(value)
    },
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    refKey: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const chartRef = ref(null)
    let chartInstance = null

    const setSize = () => {
      if (props.width) {
        cash(chartRef.value).attr({ width: props.width })
      }
      if (props.height) {
        cash(chartRef.value).attr({ height: props.height })
      }
    }

    const bindInstance = () => {
      if (props.refKey) {
        const bind = inject(`bind[${props.refKey}]`)
        if (bind) bind(chartRef.value)
      }
    }

    const initChart = () => {
      const ctx = chartRef.value.getContext('2d')
      chartInstance = new Chart(ctx, {
        type: props.type,
        data: $h?.toRaw ? $h.toRaw(props.data) : props.data,
        options: props.options
      })
      chartRef.value.instance = chartInstance
    }

    watch(
      () => props.data,
      (newData) => {
        if (chartInstance) {
          chartInstance.data = $h?.toRaw ? $h.toRaw(newData) : newData
          chartInstance.update()
        }
      },
      { deep: true }
    )

    watch(
      () => props.options,
      (newOpts) => {
        if (chartInstance) {
          chartInstance.options = newOpts
          chartInstance.update()
        }
      },
      { deep: true }
    )

    onMounted(() => {
      setSize()
      bindInstance()
      initChart()
    })

    return { chartRef }
  }
})
</script>

<style scoped>
canvas {
  display: block;
  width: 100% !important;
}
</style>
